export default "__VITE_ASSET__DzqaG6kF__"